
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class Loading extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop({ type: Boolean, default: true }) readonly initial!: boolean

  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.loading = true;
    } else {
      this.loading = false;
    }
  }

  @Watch('loading')
  onLoadingChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  created() {
    console.log('Loading: created()'); // eslint-disable-line no-console

    this.loading = this.initial;
  }
}
